import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { OnlineStatusComponent } from '../online-status';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [IonicModule, OnlineStatusComponent],
})
export class HeaderComponent {
  @Input() title = '';
}
